import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { DATE_FORMAT_DEFAULT } from '../../constants'
import { checkValidFormFieldValue } from '../../utils/helper'

const { Option } = Select

const ManagementAssetWarehousePageAdvanceFilterV2 = props => {
  const { managementAssetWarehouseStore } = props || {}
  const { managementAssetWarehouseTypes } = managementAssetWarehouseStore

  const [showFilter, setShowFilter] = useState(false)

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        asset_type_id: queryStringParse?.asset_type_id || null,
        asset_name: queryStringParse?.asset_name || null,
        createdAt:
          queryStringParse?.createdAt && queryStringParse?.createdAt
            ? moment(queryStringParse.createdAt)
            : undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      asset_type_id: values?.asset_type_id || null,
      asset_name: values?.asset_name || null,
      createdAt: values?.createdAt
        ? moment(values?.createdAt).format('YYYY-MM-DD')
        : null,
    }

    const queryStringStringify = queryString.stringify(
      {
        ...params,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/manager-inventory/inventory-asset?${queryStringStringify}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse?.asset_type_id)) count++
    if (hasValue(queryStringParse?.asset_name)) count++
    if (hasValue(queryStringParse?.createdAt)) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    history.push(`/manager-inventory/inventory-asset`)
  }

  const sortedTypes = managementAssetWarehouseTypes?.content?.sort((a, b) => {
    return a.description.localeCompare(b.description)
  })

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Loại"
                name="asset_type_id"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{
                    width: '100%',
                  }}
                  className="h-40"
                  showSearch
                  placeholder={'Lọc theo loại văn phòng phẩm'}
                  filterOption={true}
                  allowClear
                  optionFilterProp={'name'}>
                  {sortedTypes?.map(type => (
                    <Option
                      key={type.id}
                      name={type.description}
                      value={type.id}>
                      {type.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Tên văn phòng phẩm"
                name="asset_name"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Lọc theo tên văn phòng phẩm"
                  allowClear
                  className="h-40"
                />
              </Form.Item>

              <Form.Item
                label="Ngày tạo"
                name="createdAt"
                style={{ marginBottom: 16 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={'Ngày tạo '}
                  format={DATE_FORMAT_DEFAULT}
                  className="h-40"
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          title="Bộ lọc"
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'fileStore'
)(observer(ManagementAssetWarehousePageAdvanceFilterV2))
